// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"64400eee","94":"a062e57d","178":"b78f2b0f","364":"5bb8826a","470":"4f9243ef","488":"94fbb2b0","490":"ec3dd1db","511":"84843538","560":"99979bfa","611":"2f5eaa55","613":"8641dce7","738":"25e4cd14","769":"ca026831","823":"26660248","927":"9e6fda59","967":"16d9a082"}[chunkId] + ".chunk.js";
};